<script lang="ts">
  import { getAppConfig } from '../../../../common/config/app-config';
  import { getJoodMembershipType, getPriceHTMLOrFree, globalCurrencyTag } from '../../../../common/util';
  import Text from '../../../common/components/Text.svelte';
  import { getJoodCardImageUrlAtc } from '../../services/pdp-data-services';
  import HMVipDiscountCard from '../../../home-maintenance/components/HMVipDiscountCard.svelte';

  export let entry;
  $: basePrice = entry?.basePrice?.value;
  $: totalPrice = entry?.totalPrice?.value / entry?.quantity;
  $: acPriceDiscount =
    entry?.appliedAcPriceDiscount?.value > 0 ? entry?.appliedAcPriceDiscount?.value / entry?.quantity : 0;
  $: totalSaving =
    (entry?.product?.savingAmount?.value || 0) +
    (entry?.product?.cashBackPrice || 0) +
    (entry?.appliedAcPriceDiscount?.value > 0 ? acPriceDiscount : 0);
  const userPrimeLevel = getJoodMembershipType();
  $: basicPrimePrice = entry?.product?.productBasicPrimeData?.primePrice?.value;
  $: vipPrimePrice = entry?.product?.productVipPrimeData?.primePrice?.value;

  $: selectedPrimePrice =
    userPrimeLevel === 'VIPPRIME' ? vipPrimePrice : userPrimeLevel === 'BASICPRIME' ? basicPrimePrice : null;

  $: hideNoPrimeFlag = selectedPrimePrice == null;

  $: joodCardImageUrl = getJoodCardImageUrlAtc(userPrimeLevel, hideNoPrimeFlag, 75);
  const { homeMaintenanceVipMembershipActive } = getAppConfig();
</script>

{#if entry}
  <div>
    {#if basePrice !== totalPrice && (entry?.product?.savingAmount || entry?.product?.cashBackPrice || entry?.appliedAcPriceDiscount?.value > 0)}
      <div class="price-container">
        <span class="price-currencyContainer">
          <span class="price">{@html getPriceHTMLOrFree(basePrice - totalSaving)}</span>
        </span>
        <span class="vat"><Text key="extra.addtocart.inc.of.vat" /></span>
      </div>
      <div class="actual-price-container">
        <span class="price">{basePrice}</span>
        {#if totalSaving > 0}
          <span class="saving">
            <Text key="extra.addtocart.save" />
            <span class="currency">{@html globalCurrencyTag}</span>{totalSaving}
          </span>
        {/if}
      </div>
      {#if entry?.saveNonJoodPercentage?.value > 0 && userPrimeLevel !== 'NOPRIME'}
        <span class="c_todays-deals-card-off-tag dis-off-tag">
          <Text key="product.percentageDiscount.off" args={[entry?.saveNonJoodPercentage?.value]} />
        </span>
      {/if}
    {:else if basePrice !== totalPrice && entry?.saveNonJoodPercentage?.value > 0}
      <div class="price-container">
        <span class="price-currencyContainer">
          <span class="price">{@html getPriceHTMLOrFree(totalPrice)}</span>
        </span>
        <span class="vat"><Text key="extra.addtocart.inc.of.vat" /></span>
      </div>
      <div class="actual-price-container">
        <span class="price">{basePrice}</span>
        <span class="saving">
          <Text key="extra.addtocart.save" />
          {basePrice - totalPrice}
          <span class="currency">{@html globalCurrencyTag}</span>
        </span>
      </div>
      {#if entry?.saveNonJoodPercentage?.value > 0 && userPrimeLevel !== 'NOPRIME'}
        <span class="c_todays-deals-card-off-tag dis-off-tag">
          <Text key="product.percentageDiscount.off" args={[entry?.saveNonJoodPercentage?.value]} />
        </span>
      {/if}
    {:else}
      <div class="price-container {homeMaintenanceVipMembershipActive ? 'vip-member' : 'non-vip-member'}">
        <div class="price-container">
          <span class="price-currencyContainer">
            <span class="price">{@html getPriceHTMLOrFree(basePrice)}</span>
          </span>
          <span class="vat"><Text key="extra.addtocart.inc.of.vat" /></span>
        </div>
        {#if entry?.entryType === 'EXTRASERVICE' && !homeMaintenanceVipMembershipActive}
          <HMVipDiscountCard service={entry} source={window.ACC.constants.PAGESOURCE.ADDTOCARTPOPUP} />
        {/if}
      </div>
    {/if}
  </div>
  {#if entry?.saveNonJoodPercentage?.value > 0 && userPrimeLevel === 'NOPRIME'}
    <span class="c_todays-deals-card-off-tag dis-off-tag">
      <Text key="product.percentageDiscount.off" args={[entry?.saveNonJoodPercentage?.value]} />
    </span>
  {/if}
  {#if joodCardImageUrl}
    <div>
      <img src={joodCardImageUrl} alt="Jood Card" />
    </div>
  {/if}
{/if}

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';
  .dis-off-tag {
    background-color: $functional-orange;
    border-radius: 5px;
    color: $primary-white;
    font-size: 10px;
    font-weight: 700;
    line-height: 12px;
    padding: 4px 8px;
    text-transform: uppercase;
    height: fit-content;
    width: fit-content;
  }
</style>
